export interface IIntegrationChatbot {
  name: string;
  title: string;
  image: string;
  image_og: string;
  subTitle: string;
  difficulty: number;
  describe: string;
  link: string;
  blogTitle: string;
  blogImage: string;
  blogTitleLink: string;
  blogLink: string;
  blogDescription: string;
  blogItems?: IIntegrationBlog[];
  blogFooterItems?: IIntegrationBlog[];
  bannerImage: string;
  bannerImageSmall: string;
  bannerText: string;
  bannerLink: string;
}

export interface IIntegrationBlog {
  title: string;
  images: string[];
}

export const IntegrationChatbot: IIntegrationChatbot[] = [
  {
    name: 'wordpress',
    title: 'IntegrationsPage/wordpress/title',
    subTitle: 'IntegrationsPage/wordpress/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/wordpress/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403889_WordPress.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614554953_wordpress_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/wordpress/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512400130_WordPress_logotype.svg',
    blogDescription: 'IntegrationsPage/wordpress/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/wordpress/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906125470_WordPress-1new.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906125497_WordPress-2new.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-3`,
        images: [
          'https://cdn.1cdn.app/application/LOUISEBOT/24051906125442_WordPress-3new.png',
          'https://cdn.1cdn.app/application/LOUISEBOT/24050405533995_WordPress-4.png',
        ],
      },
      {
        title: `IntegrationsPage/wordpress/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405533918_WordPress-5.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405533924_WordPress-6.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-8`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405533958_WordPress-7.png'],
      },
      {
        title: `IntegrationsPage/wordpress/t-9`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405533992_WordPress-8.png'],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'shopify',
    title: 'IntegrationsPage/shopify/title',
    subTitle: 'IntegrationsPage/shopify/subTitle',
    difficulty: 2,
    describe: 'IntegrationsPage/shopify/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403827_Shopify.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614554933_shopify_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/shopify/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24051909284175_shopify_single_page.svg',
    blogDescription: 'IntegrationsPage/shopify/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/shopify/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405504942_Shopify-1.png'],
      },
      {
        title: `IntegrationsPage/shopify/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/2405040550494_Shopify-2-1.jpg'],
      },
      {
        title: `IntegrationsPage/shopify/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405504946_Shopify-2-2.jpg'],
      },
      {
        title: `IntegrationsPage/shopify/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405504914_Shopify-3.png'],
      },
      {
        title: `IntegrationsPage/shopify/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906122292_Shopify-5new.jpg'],
      },
      {
        title: `IntegrationsPage/shopify/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906122259_Shopify-6new.jpg'],
      },
      {
        title: `IntegrationsPage/shopify/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/shopify/t-8`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/shopify/t-9`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906122223_Shopify-9new.png'],
      },
      {
        title: `IntegrationsPage/shopify/t-10`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405504979_Shopify-5.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/shopify/f-1',
        images: [],
      },
    ],
    bannerImage: 'https://cdn.1cdn.app/application/LOUISEBOT/2411292306163_shopify_banner.png',
    bannerImageSmall: 'https://cdn.1cdn.app/application/LOUISEBOT/24112923061689_shopify_banner_large.png',
    bannerText: '',
    bannerLink: 'https://shopify.pxf.io/c/5745420/1499955/13624',
  },
  {
    name: 'wix',
    title: 'IntegrationsPage/wix/title',
    subTitle: 'IntegrationsPage/wix/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/wix/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403833_WIX.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614555068_wix_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/wix/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512400159_WIX_logotype.svg',
    blogDescription: 'IntegrationsPage/wix/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/wix/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405521552_wix-1.png'],
      },
      {
        title: `IntegrationsPage/wix/t-2`,
        images: [],
      },
      {
        title: `IntegrationsPage/wix/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405521559_wix-2.png'],
      },
      {
        title: `IntegrationsPage/wix/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405521570_wix-3.png'],
      },
      {
        title: `IntegrationsPage/wix/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/2405040552154_wix-4-1.png'],
      },
      {
        title: `IntegrationsPage/wix/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/wix/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/wix/t-8`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405521529_wix-4-2.png'],
      },
      {
        title: `IntegrationsPage/wix/t-9`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405521567_wix-5.jpg'],
      },
      {
        title: `IntegrationsPage/wix/t-10`,
        images: [],
      },
      {
        title: `IntegrationsPage/wix/t-11`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24050405521558_wix-6.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/wix/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'squarespace',
    title: 'IntegrationsPage/Squarespace/title',
    subTitle: 'IntegrationsPage/Squarespace/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Squarespace/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24051910363068_squarespace.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614555077_squarespace_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/Squarespace/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24051910363016_squarespace_single_page.svg',
    blogDescription: 'IntegrationsPage/Squarespace/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Squarespace/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162155_squarespace-1new.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162151_squarespace-2new.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162197_squarespace-3new.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162180_squarespace-4new.jpg'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162198_squarespace-5new.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-8`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162173_squarespace-8new.png'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-9`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162133_squarespace-9new.jpg'],
      },
      {
        title: `IntegrationsPage/Squarespace/t-10`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051911162179_squarespace-10new.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Squarespace/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'reactjs',
    title: 'IntegrationsPage/ReactJS/title',
    subTitle: 'IntegrationsPage/ReactJS/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/ReactJS/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403845_Reacts.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/2411161455502_react_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/ReactJS/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512400189_React__logotype.svg',
    blogDescription: 'IntegrationsPage/ReactJS/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/ReactJS/t-1`,
        images: [],
      },
      {
        title: `IntegrationsPage/ReactJS/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906075826_React-2new.jpg'],
      },
      {
        title: `IntegrationsPage/ReactJS/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906075899_React-3new.jpg'],
      },
      {
        title: `IntegrationsPage/ReactJS/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906075890_React-4new.jpg'],
      },
      {
        title: `IntegrationsPage/ReactJS/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/ReactJS/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906075883_React-6new.png'],
      },
      {
        title: `IntegrationsPage/ReactJS/t-7`,
        images: [],
      },
      {
        title: `IntegrationsPage/ReactJS/t-8`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/ReactJS/t-9`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051113423250_React-3.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/ReactJS/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'angular',
    title: 'IntegrationsPage/Angular/title',
    subTitle: 'IntegrationsPage/Angular/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Angular/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403852_Angular.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614555077_angular_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/Angular/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512400110_Angular_logotype.svg',
    blogDescription: 'IntegrationsPage/Angular/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Angular/t-1`,
        images: [],
      },
      {
        title: `IntegrationsPage/Angular/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/2405190606513_Angular-2new.jpg'],
      },
      {
        title: `IntegrationsPage/Angular/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906065183_Angular-3new.jpg'],
      },
      {
        title: `IntegrationsPage/Angular/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906065171_Angular-4new.jpg'],
      },
      {
        title: `IntegrationsPage/Angular/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906065149_Angular-5new.jpg'],
      },
      {
        title: `IntegrationsPage/Angular/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Angular/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051906065132_Angular-7new.jpg'],
      },
      {
        title: `IntegrationsPage/Angular/t-8`,
        images: [],
      },
      {
        title: `IntegrationsPage/Angular/t-9`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Angular/t-10`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24051113423227_Angular-3.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Angular/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'html',
    title: 'IntegrationsPage/Html/title',
    subTitle: 'IntegrationsPage/Html/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Html/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24062311343756_Html_square.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614555018_html_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/Html/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24062311343791_html-landscape.svg',
    blogDescription: 'IntegrationsPage/Html/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Html/t-1`,
        images: [],
      },
      {
        title: `IntegrationsPage/Html/t-2`,
        images: [],
      },
      {
        title: `IntegrationsPage/Html/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24061614014869_HTML-1.png'],
      },
      {
        title: `IntegrationsPage/Html/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Html/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24070212291840_image_(1).png'],
      },
      {
        title: `IntegrationsPage/Html/t-6`,
        images: [],
      },
      {
        title: `IntegrationsPage/Html/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Html/t-8`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24061614014832_HTML-3.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Html/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'bubble',
    title: 'IntegrationsPage/Bubble/title',
    subTitle: 'IntegrationsPage/Bubble/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Bubble/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24073012280095_Bubble.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24111614555157_bubble_louise.png',
    link: '',
    blogTitle: 'IntegrationsPage/Bubble/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24073012274085_Bubble_Logotype.svg',
    blogDescription: 'IntegrationsPage/Bubble/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Bubble/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24072912500097_Bubble-1.png'],
      },
      {
        title: `IntegrationsPage/Bubble/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24072912500032_Bubble-2.png'],
      },
      {
        title: `IntegrationsPage/Bubble/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Bubble/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24072912500121_Bubble-3.png'],
      },
      {
        title: `IntegrationsPage/Bubble/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Bubble/t-5`,
        images: [
          'https://cdn.1cdn.app/application/LOUISEBOT/24072912500124_Bubble-4.png',
          'https://cdn.1cdn.app/application/LOUISEBOT/24072912500152_Bubble-5.png',
        ],
      },
      {
        title: `IntegrationsPage/Bubble/t-6`,
        images: [],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Bubble/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'hostinger',
    title: 'IntegrationsPage/Hostinger/title',
    subTitle: 'IntegrationsPage/Hostinger/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Hostinger/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24113011045130_hostinger_icon.svg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24113010592038_hostinger_louisebot.png',
    link: '',
    blogTitle: 'IntegrationsPage/Hostinger/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24113010395019_logo_hostinger.svg',
    blogDescription: 'IntegrationsPage/Hostinger/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Hostinger/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113010351450_1_editor_opened.png'],
      },
      {
        title: `IntegrationsPage/Hostinger/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113012375024_2_integration_menu.png'],
      },
      {
        title: `IntegrationsPage/Hostinger/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Hostinger/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113012375190_3_add_script.png'],
      },
      {
        title: `IntegrationsPage/Hostinger/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Hostinger/t-5`,
        images: [
          'https://cdn.1cdn.app/application/LOUISEBOT/24113012375150_4_update_site.png',
          'https://cdn.1cdn.app/application/LOUISEBOT/24113010351574_5_widget_ok.png',
        ],
      },
      {
        title: `IntegrationsPage/Hostinger/t-6`,
        images: [],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Hostinger/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'brizy',
    title: 'IntegrationsPage/Brizy/title',
    subTitle: 'IntegrationsPage/Brizy/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Brizy/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24113017071960_brizy_logo.png',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24113014534141_brizy_louisebot.png',
    link: '',
    blogTitle: 'IntegrationsPage/Brizy/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24113014534022_brizy_logo.svg',
    blogDescription: 'IntegrationsPage/Brizy/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Brizy/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113014534163_1_webpage.png'],
      },
      {
        title: `IntegrationsPage/Brizy/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113014534136_2_menu.png'],
      },
      {
        title: `IntegrationsPage/Brizy/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Brizy/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113014534183_3_script.png'],
      },
      {
        title: `IntegrationsPage/Brizy/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Brizy/t-5`,
        images: [
          'https://cdn.1cdn.app/application/LOUISEBOT/24113014534214_4_save.png',
          'https://cdn.1cdn.app/application/LOUISEBOT/24113014534246_5_chatbot.png',
        ],
      },
      {
        title: `IntegrationsPage/Brizy/t-6`,
        images: [],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Brizy/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'youpage',
    title: 'IntegrationsPage/YouPage/title',
    subTitle: 'IntegrationsPage/YouPage/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/YouPage/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24113017354712_youpage_logo.png',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/24113017323631_youpage_louisebot.png',
    link: '',
    blogTitle: 'IntegrationsPage/YouPage/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/24113017323584_youpage_logo.png',
    blogDescription: 'IntegrationsPage/YouPage/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/YouPage/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113017323552_1_dashboard.png'],
      },
      {
        title: `IntegrationsPage/YouPage/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113017323571_2_btn_Advanced.png'],
      },
      {
        title: `IntegrationsPage/YouPage/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/YouPage/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113017323589_3_script.png'],
      },
      {
        title: `IntegrationsPage/YouPage/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/YouPage/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113017323577_4_widget.png'],
      },
      {
        title: `IntegrationsPage/YouPage/t-6`,
        images: [],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/YouPage/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'webstarts',
    title: 'IntegrationsPage/Webstarts/title',
    subTitle: 'IntegrationsPage/Webstarts/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Webstarts/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/2503311741482_logo_webstart.png',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/2503311741482_logo_webstart.png',
    link: '',
    blogTitle: 'IntegrationsPage/Webstarts/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/2503311741482_logo_webstart.png',
    blogDescription: 'IntegrationsPage/Webstarts/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Webstarts/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25033118460791_webstart_2.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25033118523674_webstart_add.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-1-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25033118534988_webstart_embed.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25033118550043_webstart_past_script.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25033119130028_webstart_save.png'],
      },
      {
        title: `IntegrationsPage/Webstarts/t-7`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25033119022294_webstart_final.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Webstarts/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'durable',
    title: 'IntegrationsPage/Durable/title',
    subTitle: 'IntegrationsPage/Durable/subTitle',
    difficulty: 1,
    describe: 'IntegrationsPage/Durable/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/2504052120327_durable_logo.jpeg',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/25040521185515_durable_co.png',
    link: '',
    blogTitle: 'IntegrationsPage/Durable/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/25040521185515_durable_co.png',
    blogDescription: 'IntegrationsPage/Durable/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/Durable/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25032316480226_home_btn.png'],
      },
      {
        title: `IntegrationsPage/Durable/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/Durable/t-1-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25032316480283_insert_script.png'],
      },
      {
        title: `IntegrationsPage/Durable/t-2`,
        images: [],
      },
      {
        title: `IntegrationsPage/Durable/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/Durable/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25032316480269_preview_btn.png'],
      },
      {
        title: `IntegrationsPage/Durable/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25032316480346_louise_widget.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/Durable/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
  {
    name: 'gtm',
    title: 'IntegrationsPage/GoogleTagManager/title',
    subTitle: 'IntegrationsPage/GoogleTagManager/subTitle',
    difficulty: 3,
    describe: 'IntegrationsPage/GoogleTagManager/describe',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/25033119315992_logo_gtm.png',
    image_og: 'https://cdn.1cdn.app/application/LOUISEBOT/25033119315992_logo_gtm.png',
    link: '',
    blogTitle: 'IntegrationsPage/GoogleTagManager/blogTitle',
    blogTitleLink: '',
    blogLink: '',
    blogImage: 'https://cdn.1cdn.app/application/LOUISEBOT/25033119315992_logo_gtm.png',
    blogDescription: 'IntegrationsPage/GoogleTagManager/blogDescription',
    blogItems: [
      {
        title: `IntegrationsPage/GoogleTagManager/t-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341281_1_click_tag.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-1-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/2504051034122_2_new_tag.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-1-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341332_3_new_tag_modal.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-1-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341320_4_custom_html.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014290150_copy_script.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341397_5_copy_script.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-3-1`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341394_6_add_trigger.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-3-2`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341320_7_choose_tigger.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-3-3`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341438_8_config_trigger.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-3-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25040510341444_9_add_timer.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-4`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/2504051034149_10_publish.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-5`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/25041014165227_auto_install.png'],
      },
      {
        title: `IntegrationsPage/GoogleTagManager/t-6`,
        images: ['https://cdn.1cdn.app/application/LOUISEBOT/24113010351574_5_widget_ok.png'],
      },
    ],
    blogFooterItems: [
      {
        title: 'IntegrationsPage/GoogleTagManager/f-1',
        images: [],
      },
    ],
    bannerImage: '',
    bannerImageSmall: '',
    bannerText: '',
    bannerLink: '',
  },
];
